import { useState } from "react";
import { X } from "lucide-react";
import { toast } from "sonner";
import { api, fmtErr } from "@/lib/api";
import { PasswordFields, passwordProblem } from "@/components/app/PasswordFields";

export default function ChangePasswordDialog({ onClose }) {
  const [current, setCurrent] = useState("");
  const [pw, setPw] = useState({ next: "", confirm: "" });
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    const p = passwordProblem(pw.next, pw.confirm);
    if (p) { toast.error(p); return; }
    setBusy(true);
    try {
      const { data } = await api.post("/auth/change-password", { current_password: current, new_password: pw.next });
      if (data.token) localStorage.setItem("tp_token", data.token);
      toast.success("Password changed. Other devices have been signed out.");
      onClose();
    } catch (err) { toast.error(fmtErr(err.response?.data?.detail)); }
    finally { setBusy(false); }
  };

  return (
    <div className="fixed inset-0 z-50 bg-slate-900/40 grid place-items-center p-4" onMouseDown={(e) => e.target === e.currentTarget && !busy && onClose()}>
      <form onSubmit={submit} className="w-full max-w-sm bg-white rounded-2xl border border-slate-200 shadow-xl p-6" data-testid="change-password-dialog">
        <div className="flex items-start justify-between mb-4">
          <div>
            <h2 className="text-lg font-semibold text-slate-900">Change password</h2>
            <p className="text-xs text-slate-500 mt-0.5">You'll stay signed in here; other devices are signed out.</p>
          </div>
          <button type="button" onClick={onClose} className="p-1 text-slate-400 hover:text-slate-700" data-testid="change-password-close"><X className="w-4 h-4" /></button>
        </div>
        <label className="text-xs font-semibold uppercase tracking-wider text-slate-500">Current password</label>
        <input data-testid="change-current-password" type="password" autoComplete="current-password" required value={current} onChange={(e) => setCurrent(e.target.value)}
          className="w-full mt-1 mb-4 px-3 py-2.5 rounded-lg border border-slate-200 focus:border-blue-500 focus:ring-2 focus:ring-blue-100 outline-none text-sm" />
        <PasswordFields value={pw} onChange={setPw} prefix="change" />
        <div className="flex justify-end gap-2 mt-6">
          <button type="button" onClick={onClose} className="px-3.5 py-2 text-sm rounded-lg border border-slate-300 text-slate-700 hover:bg-slate-50" data-testid="change-password-cancel">Cancel</button>
          <button disabled={busy} className="px-3.5 py-2 text-sm rounded-lg bg-indigo-600 hover:bg-indigo-500 text-white font-medium disabled:opacity-60" data-testid="change-password-submit">{busy ? "Saving…" : "Update password"}</button>
        </div>
      </form>
    </div>
  );
}
